import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/api';
import { track } from '../lib/analytics';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { setUser } = useAuth();

  useEffect(() => {
    const token = params.get('token');
    const error = params.get('error');

    if (error) {
      navigate('/login?error=' + error);
      return;
    }

    if (token) {
      localStorage.setItem('token', token);
      if (params.get('new') === '1') track('sign_up', { method: 'google' });
      api.get('/api/auth/me')
        .then(({ data }) => {
          localStorage.setItem('user', JSON.stringify(data));
          setUser(data);
          if (data.role === 'admin') navigate('/admin');
          // Trial mode: a brand-new (unpaid) account pays for the trial before onboarding.
          else if (data.trial?.status === 'unpaid') navigate('/checkout?plan=trial');
          // New / not-yet-onboarded students go straight to onboarding
          // (Create account → Onboarding → Dashboard — no pricing detour).
          else if (data.onboarding_completed === false) navigate('/onboarding');
          else navigate('/dashboard');
        })
        .catch(() => {
          localStorage.removeItem('token');
          navigate('/login?error=auth_failed');
        });
    } else {
      navigate('/login');
    }
  }, [params, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50">
      <div className="text-center">
        <div className="animate-spin w-8 h-8 border-4 border-primary border-t-transparent rounded-full mx-auto mb-4" />
        <p className="text-neutral-500 text-sm">Completing sign in...</p>
      </div>
    </div>
  );
}
